/**
 * @generated SignedSource<<5a792d0e639f39d8ba7dd0033f86af2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserDetailsImageInput_user$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_user">;
  readonly " $fragmentType": "UserDetailsImageInput_user";
};
export type UserDetailsImageInput_user$key = {
  readonly " $data"?: UserDetailsImageInput_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserDetailsImageInput_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserDetailsImageInput_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAvatar_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d09da1c1a2cc31d6e58be9bcc8d412c3";

export default node;
